import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FreudMessage, FreudMessageService } from '@freud-ds/web-components';
import { TranslateService } from '@ngx-translate/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { environment } from 'environments/environment';
import { DateTime } from 'luxon';
import { ExportService } from 'modules/exports/services/export.service';

import { ActionTrackerService } from './../../../../app/services/actiontracker.service';

@Component({
	selector: 'app-promptuary-export',
	templateUrl: './promptuary-export.component.html',
	styleUrls: ['./promptuary-export.component.scss'],
})
export class PromptuaryExportComponent implements OnInit {
	public isRecaptchaResolved = false;
	public recaptchaToken = null;
	public exportData = null;
	public isExperied = false;
	public isDownloading = false;
	public recaptchaSiteKey = environment.google.recaptcha;
	public exportId = null;

	constructor(
		private router: Router,
		private exportService: ExportService,
		private messageService: FreudMessageService,
		private translate: TranslateService,
		private currentRoute: ActivatedRoute,
		private atService: ActionTrackerService
	) {}

	ngOnInit(): void {
		this.trackPageView();
		this.exportId = this.currentRoute.snapshot.paramMap.get('exportId');
		this.exportService
			.getExportData(this.exportId)
			.toPromise()
			.then((res) => {
				this.exportData = {
					...res,
					startDate: res.createdAt
						? DateTime.fromISO(res.createdAt).toFormat('dd/MM/yyyy')
						: '',
					endDate: res.validUntil
						? DateTime.fromISO(res.validUntil).toFormat('dd/MM/yyyy')
						: '',
				};
				this.isExperied = res.isExpired;
			})
			.catch(() => {
				this.router.navigateByUrl('/calendar');
			});
	}

	onRecaptchaResolved(e) {
		if (e) {
			this.isRecaptchaResolved = true;
			this.recaptchaToken = e;
		}
	}

	redirectToCalendar() {
		this.router.navigateByUrl('/calendar');
	}

	downloadPromptuary() {
		if (this.isRecaptchaResolved) {
			this.isDownloading = true;
			this.exportService
				.downloadPromptuary(this.exportId, this.recaptchaToken)
				.toPromise()
				.then((res) => {
					const filename = res.headers.get('Content-Disposition').split('=')[1];
					const dataType = res.body.type;
					const binaryData = [];
					binaryData.push(res.body);
					const downloadLink = document.createElement('a');
					downloadLink.href = window.URL.createObjectURL(
						new Blob(binaryData, { type: dataType })
					);
					downloadLink.setAttribute('download', filename);
					document.body.appendChild(downloadLink);
					downloadLink.click();
					this.toastSuccess(this.translate.instant('EXPORT.DOWNLOAD_SUCCESS'));
					this.atService.eventTracker(
						SCOPE_TYPE.Promptuary,
						SUBSCOPE_TYPE.Export,
						ITEM_TYPE.Download,
						INTERACTION_TYPE.Success,
						{}
					);
				})
				.catch(() => {
					this.atService.eventTracker(
						SCOPE_TYPE.Promptuary,
						SUBSCOPE_TYPE.Export,
						ITEM_TYPE.Download,
						INTERACTION_TYPE.Error,
						{}
					);
				})
				.finally(() => {
					this.isDownloading = false;
				});
			this.isRecaptchaResolved = false;
		}
	}

	toastSuccess(summary) {
		const message: FreudMessage = {
			severity: 'success',
			summary: summary,
			detail: null,
		};
		this.messageService.add(message);
	}

	trackPageView() {
		this.atService.eventTracker(
			SCOPE_TYPE.Promptuary,
			SUBSCOPE_TYPE.Export,
			ITEM_TYPE.Page,
			INTERACTION_TYPE.View,
			{}
		);
	}
}
